export default __webpack_public_path__ + "static/media/ic-students.e6082c59.svg";